import { render } from "./ProfileSettings.vue?vue&type=template&id=bfc87c10"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ProfileSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfc87c10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfc87c10', __exports__)) {
    api.reload('bfc87c10', __exports__)
  }
  
  module.hot.accept("./ProfileSettings.vue?vue&type=template&id=bfc87c10", () => {
    api.rerender('bfc87c10', render)
  })

}


export default __exports__